import { render, staticRenderFns } from "./TodaySusHoldList.vue?vue&type=template&id=d64bb1ca&scoped=true"
import script from "./TodaySusHoldList.vue?vue&type=script&lang=js"
export * from "./TodaySusHoldList.vue?vue&type=script&lang=js"
import style0 from "./TodaySusHoldList.vue?vue&type=style&index=0&id=d64bb1ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64bb1ca",
  null
  
)

export default component.exports